/** @format */
import { ResizeObserver } from '@juggle/resize-observer';
import { RefObject, useEffect, useRef, useState } from 'react';

/**
 * @deprecated use Feather/hooks/use-measure instead
 *
 * A hook used to measure the dimensions of the component
 * @param ref The ref to measure
 */
export function useMeasure(ref: RefObject<HTMLElement | null>) {
    const [bounds, set] = useState({ width: 0, height: 0 });
    const ro = useRef(
        new ResizeObserver(([entry]) => {
            const { inlineSize: width, blockSize: height } =
                entry.borderBoxSize[0];
            set({ width, height });
        })
    );

    useEffect(() => {
        if (ref.current) ro.current.observe(ref.current, { box: 'border-box' });
        return () => ro.current.disconnect();
    }, []);

    return bounds;
}
